import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Post from './Post';
import { Categories } from '../../../static/categories';
import { firestore } from 'firebase';
import Fog from '../../../components/elements/fog/Fog';
import { Card } from 'reactstrap';
import PostHeader from './PostHeader';
import PostBody from './PostBody';
import PostFooter from './PostFooter';
import { When } from 'react-if';
import CreateReviewForm from './CreateReviewForm';
import { ApproveDeclinePost } from '../../../components/post/admin/ApproveDeclinePost';
import { DeletePostButton } from '../../../components/post/elements/DeletePostButton/DeletePostButton';
import { EditPostButton } from '../../../components/post/elements/EditPostButton/EditPostButton';
import PostInviteModal from '../../../components/elements/customModals/PostInviteModal/PostInviteModal';
import EmailAllModal from '../../../components/elements/customModals/EmailAllModal';
import DeletePostModal from '../../../components/elements/modal/DeletePostModal';
import * as QUESTION from '../../../constants/questions';

const DEFAULT_TIMESTAMP_SECONDS = 1590846592;

const LoadingPost = ({ style }) => {
    const renderFogText = useCallback(() => {
        return <h6 className="font-weight-bold mr-4 card-info fog__text-header">Loading...</h6>;
    }, []);

    return (
        <Fog isVisible={true} text={renderFogText}>
            <div className="row" style={style}>
                <Card className="post__container">
                    <PostHeader
                        categoryId={Categories['r1cq9ri9p9'].label}
                        createdTimestamp={new firestore.Timestamp(DEFAULT_TIMESTAMP_SECONDS, 0)}
                        firstName="Sandra"
                        lastName="M"
                        totalDonations={78}
                        reviewsCount={10}
                    />
                    <Fog isVisible={false} text={renderFogText}>
                        <PostBody
                            title="Example question titles to go here. Bla bla bla bla bla…"
                            description="Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit."
                            media={[]}
                            questionType={QUESTION.YES_NO}
                            questions={[]}
                            onMultipleClick={() => {}}
                        />
                    </Fog>
                    <PostFooter
                        reviews={[]}
                        questions={[]}
                        categoryId={Categories['r1cq9ri9p9'].label}
                        questionType={QUESTION.YES_NO}
                        alreadyReviewed={false}
                        isPostOwner={false}
                        onClick={() => {}}
                        onMultipleQuestionClick={() => {}}
                        onReviewsOpen={() => {}}
                        onEmailAllButtonClick={() => {}}
                        onInviteFriendsButtonClick={() => {}}
                    />
                </Card>
            </div>
        </Fog>
    );
};

LoadingPost.propTypes = {
    style: PropTypes.object.isRequired,
};

export default React.memo(LoadingPost);
